module.exports = __webpack_public_path__ + "static/media/logo-danone.ed80f185.png";